import { render, staticRenderFns } from "./AgencyCommission.vue?vue&type=template&id=986bedd4&scoped=true&"
import script from "./AgencyCommission.vue?vue&type=script&lang=js&"
export * from "./AgencyCommission.vue?vue&type=script&lang=js&"
import style0 from "./AgencyCommission.vue?vue&type=style&index=0&id=986bedd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986bedd4",
  null
  
)

export default component.exports